import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'
import { Splide } from '@splidejs/splide'

const app = Application.start()

app.register('refosumu--example-show--reform-example-card--component', class extends Controller {
  connect() {
    this.initializeSlider()
  }

  initializeSlider() {
    const splideElement = this.element.querySelector('.splide')
    if (!splideElement) return

    const slideCount = splideElement.querySelectorAll('.splide__slide').length

    new Splide(splideElement, {
      speed: 800,
      perPage: 1,
      perMove: 1,
      pagination: false,
      arrows: slideCount > 1,
      gap: '16px',
      padding: { left: 0, right: 0 },
    }).mount()
  }
})
